/**
 * Define a regex to validate a string contains only letters
 */
export const onlyLettersRegex = /^[a-zA-Z]+$/;
